// Module
var code = "<div class=\"br-caption-2\" md-colors=\"{ background: $ctrl.backColor || 'black' }\"> <span md-colors=\"{color: 'White'}\"> {{'Auction' | translate}} {{$ctrl.status | translate}}</span> </div> ";
// Exports
export default code;